import { InjectionToken } from '@angular/core';

export const SOFTLINE_FEATURE_LAGERPLATZ_SUCHE = 'lagerplatzSuche'
export const SOFTLINE_FEATURE_LAGERSYMBOL = 'lagersymbol';

export type LagerplatzAuswahl = 'scan' | 'select' | 'scanAndSelect';
export const SOFTLINE_CONFIG_LAGERPLATZ_AUSWAHL = new InjectionToken<LagerplatzAuswahl>('SOFTLINE_CONFIG_LAGERPLATZ_AUSWAHL',
  { providedIn: 'root', factory: () => 'scan' });
